import { CropTypeDtoSchema } from "@campaign/data/dto/crop-type.dto";
import type { Nullable } from "@core/domain/types/nullable.type";
import * as z from "zod";

export const StationTypeEnumSchema = z.enum([
    "Agronic",
    "Aqua",
    "Box Counter",
    "Camera",
    "CameraMeteo",
    "Geo",
    "Gps",
    "Handheld",
    "ElectricMeter",
    "MeteoMobile",
    "Meteo",
    "Track",
    "Trap",
]);

export type StationTypeEnum = z.output<typeof StationTypeEnumSchema>;

const DecisionSupportSystemsDtoSchema = z
    .object({
        id: z.number(),
        configuration: z.object({
            id: z.number(),
            type: z.string().trim(),
            name: z.string().trim(),
            description: z.string().trim().nullable(),
        }),
    })
    .readonly();

const PoiDtoSchema = z
    .object({
        id: z.number(),
        code: z.string().trim(),
        name: z.string().trim(),
        technical_name: z.string().trim(),
        type: z.string().trim(),
    })
    .readonly();

export const StationDtoSchema = z
    .object({
        id: z.number(),
        code: z.string().trim(),
        name: z.string().trim().nullable(),
        technical_name: z.string().trim().nullable(),
        latitude: z.string().trim().nullable(),
        longitude: z.string().trim().nullable(),
        radius: z.number().nullable(),
        type: StationTypeEnumSchema.nullable(),
        old_threshold_hours: z.number().nullable(),
        client_company: z.string().trim().nullable(),
        icon: z.string().trim(),
        last_frame_at: z.string().trim().nullable(),
        last_frame_timestamp: z.string().trim().nullable(),
        vehicle_type: z.string().trim().nullable(),
        allow_drainage_report: z.boolean().nullable(),
        decision_support_systems: z
            .array(DecisionSupportSystemsDtoSchema)
            .nullable(),
        pois: z.array(PoiDtoSchema).nullable(),
        battery_percentage: z.number().nullish(),
        campaign_active: z
            .object({
                id: z.number(),
                name: z.string().trim(),
                crop_type: CropTypeDtoSchema,
            })
            .nullable(),
    })
    .readonly();

export type StationDto = z.output<typeof StationDtoSchema>;

export interface StationUpdateBody {
    station: {
        name: string;
        technical_name: Nullable<string>;
        latitude: Nullable<string>;
        longitude: Nullable<string>;
    };
}
